<template>
  <div class="doomyogaregister doomyoga-auth-container h-100">
    <div class="h-100">
      <div class="row h-100 m-0">
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 my-auto">
          <Register 
          logoSrc="doom-yoga/Doomyoga-logo.png"
          welcomeHeader="Book as a guest"
          guard="DY" clientLink="doom_yoga"  is_guest="true"/>
        </div>
        <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 my-5">
          <div class="container my-3" id="doomYogaImdDiv">
            <img
              class="img-fluid mx-auto"
              id="doomYogaLoginImg"
              src="@/assets/images/doom-yoga/doom-yoga-login-image2.png"
              alt="doomyoga Logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/auth/Register";

export default {
  name: "DoOmYogaBookAsGuest",
  components: { Register },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit signup");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../../css/doom-yoga-fonts.css";
@import "../../css/doom-yoga-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Events/BookAsGuest.vue